import React, { useState } from 'react';

import { Button, RadioButton } from '@components/common';

import { currentTimeZoneInMinutes } from '@utils/timeUtils';

import { IFileTypeSelectionFormParams } from './FileTypeSelectionForm.types';

import { EExportFileTypes, TExportFileTypes } from '@enums/common';

import { EExportActionsTypes } from './constants';

import './FileTypeSelectionForm.scss';

const FileTypeSelectionCommonForm = ({
	activeExportAction,
	closeModals,
	handlePreparingExport,
	isLoading,
	selectedIds = null,
	toggleModal,
	filter,
	exportRadioButtonsData,
}: IFileTypeSelectionFormParams) => {
	const [activeRadioButton, setActiveRadioButton] = useState<TExportFileTypes>(EExportFileTypes.csv);

	const onSubmit = () => {
		handlePreparingExport({
			timeZoneMinutes: currentTimeZoneInMinutes,
			fileType: activeRadioButton,
			ids: selectedIds,
			filter: activeExportAction === EExportActionsTypes.allFiltered && filter
				? filter
				: null,
		});

		closeModals();
	};

	return (
		<div>
			<div className='f5gFileTypeSelectionFormButtonGroup'>
				{
					exportRadioButtonsData.map((btn) => {
						const onChange = (id: TExportFileTypes) => {
							setActiveRadioButton(id);
						};

						return (
							<div
								key={`${btn.name}-parent`}
								className='f5gFileTypeSelectionFormRadioBtnContainer'
							>
								<RadioButton
									key={btn.name}
									checked={activeRadioButton === btn.name}
									id={btn.name}
									label={btn.label}
									name={btn.name}
									onChange={onChange}
									value={btn.name}
								/>
							</div>
						);
					})
				}
			</div>
			<div className='f5gFileTypeSelectionFormSubmitButtons'>
				<Button
					onClick={toggleModal}
					text='Cancel'
					withoutBackground
				/>
				<Button
					disabled={!activeRadioButton || isLoading}
					onClick={onSubmit}
					text='Export'
				/>
			</div>
		</div>
	);
};

export default FileTypeSelectionCommonForm;
